function getPotionsCart() {

  const SITE_ID = 627;
  const EXPERIENCE_ID = "fec5f603-98e3-4290-bba5-f84d0f94701d";

  const grid = document.querySelector(`#upsell-products`);
  const grid_mobile = document.querySelector(`#upsell-products-mobile`);

  // if not grid, then return
  if (!grid) {
    return;
  }

  const viewed_items = [];
  viewed_items.push(window.current_product);

  // récupérer le montant restant 'free_shipping_indicator'
  const freeShippingIndicator = document.querySelector('.free_shipping_indicator');
  let amountLeftForFreeDelivery = 0;

  if (freeShippingIndicator) {
    amountLeftForFreeDelivery = parseFloat(freeShippingIndicator.getAttribute('data-restant'));
    if (amountLeftForFreeDelivery < 0) {
      amountLeftForFreeDelivery = 0;
    }
  }

  if (grid) {
    grid.innerHTML = '';
  }
  if (grid_mobile) {
    grid_mobile.innerHTML = '';
  }

  async function getCartItems() {
    let cart_items = [];

    try {
      const response = await fetch('/cart.json');
      const data = await response.json();
      //console.log("Cart data:", data);
      cart_items = data.items.map(item => item.product_id.toString());
    } catch (error) {
      console.error('Erreur:', error);
    }

    return cart_items;
  }

  (async () => {
    const cart_items = await getCartItems();
    const adding_to_cart_item = ["" + cart_items[0] + ""];

    const QUERY = JSON.stringify({
      "amount_left_for_free_delivery": amountLeftForFreeDelivery,
      "cart_items": cart_items,
      "visitor_country": window.visitor_country,
      "viewed_items": viewed_items,
      "adding_to_cart_item": adding_to_cart_item
    });

    fetch(`https://client.experiences.get-potions.com/v1/${SITE_ID}/experience/${EXPERIENCE_ID}?variables=${QUERY}`)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {

        // Check if products exist in the response
        if (data && data.products) {

          //console.log("potions upsell : ", data.products);

          if (data.products.length === 0) {
            document.querySelector(`#upsell`).style.display = 'none';
            document.querySelector(`#upsell_mobile`).style.display = 'none';
          }
          else {
            if (window.innerWidth > 749) {
              document.querySelector(`#upsell`).style.display = 'block';
              document.querySelector(`#upsell_mobile`).style.display = 'none';
            }
            else {
              document.querySelector(`#upsell`).style.display = 'none';
              document.querySelector(`#upsell_mobile`).style.display = 'block';
            }
          }

          for (let i = 0; i < data.products.length; i++) {
            // On s'arrête à X produits max.
            if (i === 5) {
              break;
            }

            // On extrait le handle du produit fourni par Potions
            var product_handle = `${data.products[i].link}`.replace("/products/", "");

            // On récupère les informations du produits depuis Shopify, pour avoir les informations les plus à jour
            fetch(window.Shopify.routes.root + 'products/' + product_handle + '.js')
              .then(function (res) {
                return res.json();
              })
              .then(card_product => renderPotionProductCard(card_product, i));
          }
        } else {
          document.querySelector(`#upsell`).style.display = 'none';
        }
      })
      .catch(function (error) {
        console.error('Error:', error);
      });
  })();
}

function renderPotionProductCard(card_product, loopindex) {
  const grid = document.querySelector(`#upsell-products`);
  const grid_mobile = document.querySelector(`#upsell-products-mobile`);
  const productDiv = document.createElement('div');

  // add an id to this div
  productDiv.id = `Slide-upsell-${loopindex}`;

  let variants = card_product.variants.filter(variant => variant.available === true).map(variant => {
    return {
      id: variant.id,
      title: variant.title,
      price: variant.price
    }
  });

  let selectHTML = '';
  if (variants.length > 1) {
    selectHTML = `
      <select name="upsell_variant_id" class="upsell_select">
        ${variants.map(variant => `<option value="${variant.id}" data-price="${variant.price}">${variant.title}</option>`).join('')}
      </select>
    `;
  }

  const productHTML = `
      <div class="upsell_item">
        <a href="${card_product.url}" class="upsell_img"><img src="${card_product.featured_image}&width=240" alt="${card_product.title}" /></a>
        <div class="upsell_item_info">
          <a href="${card_product.url}" class="upsell_product_title">${card_product.title}</a>
          ${selectHTML}
          <button class="upsell_add_to_cart" data-reco-click="add_to_cart_item" data-item-id="${card_product.variants[0].id}" data-product_id="${card_product.variants[0].id}">${window.add_to_cart} | <span class="upsell_price">${card_product.price / 100}</span> €</button>
          <input type="hidden" name="form_type" value="product">
          <input type="hidden" name="utf8" value="✓">
        </div>
      </div>
    `;

  productDiv.innerHTML = productHTML;

  // Clonage de productDiv avec tout son contenu
  const productDivClone = productDiv.cloneNode(true);

  // Ajout de la carte produit au DOM
  if (grid) {
    grid.appendChild(productDiv);
  }
  if (grid_mobile) {
    grid_mobile.appendChild(productDivClone);
  }

  // in grid, sort all the cards by their ID
  const cards = Array.from(grid.children).sort((a, b) => a.id.localeCompare(b.id));
  grid.innerHTML = '';
  cards.forEach(card => grid.appendChild(card));

}